import React from "react";
import "./contact.css";
import Instagram from "../../Assets/instagram.svg";
import WhatsApp   from "../../Assets/whatsapp.svg";
import EmailIcon  from "../../Assets/gmail.svg";
import Phone      from "../../Assets/phone.svg";
import Map        from "../../Assets/map.svg";
import Facebook   from "../../Assets/facebook.svg";

const SOCIAL = [
  {
    label: "Instagram",
    sub: "@shree_photos_films",
    href: "https://www.instagram.com/shree_photos_films",
    icon: Instagram,
    color: "#E1306C",
  },
  {
    label: "WhatsApp",
    sub: "+91 73836 77715",
    href: "https://wa.me/917383677715",
    icon: WhatsApp,
    color: "#25D366",
  },
  {
    label: "Facebook",
    sub: "Shree Photos Films",
    href: "https://www.facebook.com/share/16v9LtdKjw/",
    icon: Facebook,
    color: "#1877F2",
  },
];

const INFO = [
  {
    icon: Phone,
    label: "Call Us",
    value: "+91 73836 77715",
    href: "tel:7383677715",
  },
  {
    icon: EmailIcon,
    label: "Email Us",
    value: "shreephotosfilms@gmail.com",
    href: "mailto:shreephotosfilms@gmail.com",
  },
  {
    icon: Map,
    label: "Visit Us",
    value: "Shop No. 09, Olympia, Shreejinagari Road, opp. Piramyd Stone Gallery, Jahangirabad, Sima Nagar, Surat, Gujarat 395009",
    href: "https://maps.app.goo.gl/paRc42yqn1xfKDfh7",
  },
];

const Contact = () => {
  return (
    <section id="Contact" className="ct-section">

      {/* ── HEADER ── */}
      <div className="ct-header">
        <span className="ct-eyebrow">Get In Touch</span>
        <h2 className="ct-title">Contact Us</h2>
        <div className="ct-ornament">
          <span />
          <svg width="14" height="14" viewBox="0 0 24 24" fill="#C9A84C">
            <path d="M12 2l2.4 7.4H22l-6.2 4.5 2.4 7.4L12 17l-6.2 4.3 2.4-7.4L2 9.4z"/>
          </svg>
          <span />
        </div>
        <p className="ct-subtitle">
          We'd love to capture your special moments. Let's talk!
        </p>
      </div>

      {/* ── THREE-COLUMN GRID ── */}
      <div className="ct-grid">

        {/* ── LEFT: CONTACT INFO ── */}
        <div className="ct-col ct-col--left">
          <p className="ct-col-heading">Contact Details</p>
          <div className="ct-info-cards">
            {INFO.map(({ icon, label, value, href }) => (
              <a key={label} href={href} className="ct-info-card" target="_blank" rel="noopener noreferrer">
                <div className="ct-info-icon">
                  <img src={icon} alt={label} />
                </div>
                <div className="ct-info-text">
                  <span className="ct-info-label">{label}</span>
                  <span className="ct-info-value">{value}</span>
                </div>
                <svg className="ct-info-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="9 18 15 12 9 6"/>
                </svg>
              </a>
            ))}
          </div>
        </div>

        {/* ── CENTRE: MAP ── */}
        <div className="ct-col ct-col--center">
          <p className="ct-col-heading">Find Us</p>
          <div className="ct-map">
            <iframe
              title="Shree Photos Films Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3720.1!2d72.8!3d21.2!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be04e0000000000%3A0x0!2sShree+Photos+Films%2C+Surat!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
            <a
              href="https://maps.app.goo.gl/CTLskxmdFMZ9XG147"
              target="_blank"
              rel="noopener noreferrer"
              className="ct-map-link"
            >
              Open in Google Maps →
            </a>
          </div>
        </div>

        {/* ── RIGHT: SOCIAL ── */}
        <div className="ct-col ct-col--right">
          <p className="ct-col-heading">Connect With Us</p>
          <div className="ct-socials">
            {SOCIAL.map(({ label, sub, href, icon, color }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className="ct-social-btn"
                style={{ "--social-color": color }}
              >
                <img src={icon} alt={label} className="ct-social-icon" />
                <div className="ct-social-text">
                  <span className="ct-social-label">{label}</span>
                  <span className="ct-social-sub">{sub}</span>
                </div>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ color: color, opacity: 0.7 }}>
                  <polyline points="9 18 15 12 9 6"/>
                </svg>
              </a>
            ))}
          </div>

          {/* Quick WhatsApp CTA */}
          <div className="ct-quick-cta">
            <p className="ct-quick-cta-text">Ready to book your event?</p>
            <a href="https://wa.me/917383677715" target="_blank" rel="noopener noreferrer" className="ct-whatsapp-btn">
              <img src={WhatsApp} alt="WhatsApp" className="ct-wa-icon" />
              Chat on WhatsApp
            </a>
          </div>
        </div>

      </div>
    </section>
  );
};

export default Contact;
